import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LoginPage } from './LoginPage';
import { FullPageLoader } from './layout/FullPageLoader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { session, loading } = useAuth();

  if (loading) {
    return <FullPageLoader />;
  }

  if (!session) {
    return <LoginPage />;
  }

  return <>{children}</>;
};
